import styles from './Legend.module.css';
import { Body, BodyColor, BodyType, Heading, InfoPanel, TypographyColor, TypographyType } from '..';
import { useRecoilValue } from 'recoil';
import { cifTypeState, rootProps, selAggLayerState, SingleLegend, userCurrencyState } from '../../states';
import { formatNumberWithUnit, useMapHelpers } from '../../helpers';
import equal from 'fast-deep-equal';

interface LegendProps {
    data: any;
    classname?: string;
    legendShimmer: boolean;
    geoCode: number;
    mapColorRootProps: rootProps
}

export const Legend: React.FC<LegendProps> = ({ data, classname, legendShimmer, geoCode, mapColorRootProps }) => {
    const selCurrency = useRecoilValue(userCurrencyState);
    const cifType = useRecoilValue(cifTypeState);
    const selAggLayer = useRecoilValue(selAggLayerState);
    const { getCurrencyWithSymbol } = useMapHelpers();
    const selMetrics = JSON.parse(localStorage?.getItem("selMetrics") || '{}');

    const metric_type = (!selMetrics || Object.values(selMetrics).filter((item: any) => !!item).length === 0)
        ? cifType.map((item: any) => ({ key: item, ismetric: false }))
        : Object.values(selMetrics)
            .map((metric: any) => {
                const { title, ...rest } = metric || {};
                return { ...rest };
            }) || [];

    const isGeoChanged = (geoCode != mapColorRootProps?.geoId) || !equal(metric_type, mapColorRootProps?.metric_type);

    return (
        <>
            {legendShimmer && isGeoChanged ?
                <div className='w-100 position-relative margin-top-2 height-4vh'>
                    <div className="d-flex justify-content-center align-items-center shimmer position-absolute" ></div>
                </div> :

                (
                    <div className={`d-flex flex-column gap-2 bg-white p-0 padding-right-4 padding-top-1 rounded w-100 ${styles.legend_font_style} ${classname}`}>
                        <div className="d-flex">
                            <div className="col-6 d-flex gap-2 justify-content-start align-items-center">
                                <div className={`col-1 ${styles.legend} ${styles.filtered_region_legend}`} />
                                <Heading
                                    title={'Filtered Region'}
                                    type={TypographyType.h6}
                                    colour={TypographyColor.secondary}
                                    classname='text-start'
                                />
                                {/* <InfoPanel classname='fs-14 icon-gray-0' text='The region has been filtered out by your preferences' /> */}
                            </div>
                            {cifType?.length > 0 && selAggLayer !== null &&
                                <div className="col-6 d-flex gap-2 justify-content-start align-items-center">
                                    <div className={`col-1 ${styles.legend} ${styles.no_poi_coverage_legend}`} />
                                    <Heading
                                        title={'No PoI Data'}
                                        type={TypographyType.h6}
                                        colour={TypographyColor.secondary}
                                        classname='text-start'
                                    />
                                    {/* <InfoPanel classname='fs-14 icon-gray-0' text='The region does not have coverage across all selected data layers' /> */}
                                </div>}
                        </div>
                        {cifType?.length > 0 && selAggLayer !== null &&
                            <div className="d-flex flex-column">
                                <div className={`w-100 ${styles.legend}`} style={{ background: `linear-gradient(90deg, ${data?.legendStartColor} 0%, ${data?.legendEndColor} 100%)` }} />
                                <div className='padding-top-2'>
                                    {data?.legendLabels?.map((item: any) => (
                                        <div key={item.legendLabel} className='d-flex align-items-center justify-content-between'>
                                            <Body
                                                type={BodyType.p4}
                                                color={BodyColor.secondary}
                                                classname="p-0 icon-gray-0 text-start col-3"
                                            >
                                                {item.legendLabel === 'CTV' ? getCurrencyWithSymbol(formatNumberWithUnit(item.legendStart), selCurrency) : item.legendStart}
                                            </Body>
                                            <Body
                                                type={BodyType.p4}
                                                color={BodyColor.secondary}
                                                classname="p-0 icon-gray-0 text-center col-6"
                                            >
                                                {item.legendLabel}
                                            </Body>
                                            <Body
                                                type={BodyType.p4}
                                                color={BodyColor.secondary}
                                                classname="p-0 text-end col-3"
                                            >
                                                {item.legendLabel === 'CTV' ? getCurrencyWithSymbol(formatNumberWithUnit(item.legendEnd), selCurrency) : item.legendEnd}
                                            </Body>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }
                    </div>)
            }
        </>
    );
};